import * as v from "valibot";

/**
 * Inscrição na lista — schema compartilhado pelo formulário
 * (app/ui/EntreNaLista.tsx) e pelo servidor (server/src/index.ts). O cliente
 * valida para dar erro na hora; o servidor revalida porque um cliente
 * hostil posta o JSON que quiser.
 *
 * O desenho segue a seção de LGPD do docs/plano-marketing-2026.md:
 * consentimento explícito e registrado, nenhuma caixa pré-marcada,
 * finalidades separadas (conteúdo ≠ oferta paga) e duplo opt-in.
 */

/**
 * O texto exato que a pessoa aceita. Fica gravado junto com a inscrição,
 * porque a prova de consentimento é o texto que estava na tela naquele dia,
 * não o que está na tela hoje. Mudou a redação? Sobe a versão.
 */
export const CONSENTIMENTO_CONTEUDO =
  "Quero receber por e-mail a explicação escrita e os arquivos de cada vídeo novo.";
export const CONSENTIMENTO_OFERTAS =
  "Pode me avisar quando você lançar um curso ou outro material pago.";
export const CONSENTIMENTO_VERSAO = "2026-11-04";

export const InscricaoSchema = v.object({
  email: v.pipe(
    v.string(),
    v.trim(),
    v.toLowerCase(),
    v.email("Esse e-mail não parece válido."),
    v.maxLength(120, "Esse e-mail é longo demais."),
  ),
  /** Obrigatório: é a finalidade principal, sem ela não há inscrição. */
  consenteConteudo: v.literal(
    true,
    "Marque a primeira caixa para eu poder te mandar os e-mails.",
  ),
  /** Opcional e separado: avisar de produto pago é outra finalidade. */
  consenteOfertas: v.optional(v.boolean(), false),
  /** De onde a pessoa veio (utm_source, utm_campaign), só para medir. */
  origem: v.optional(v.pipe(v.string(), v.maxLength(120))),
  /** Anti-robô: gente de verdade não preenche um campo escondido. */
  honeypot: v.optional(v.pipe(v.string(), v.maxLength(0))),
});

export type Inscricao = v.InferOutput<typeof InscricaoSchema>;

/** O texto aceito, montado para gravar no banco. */
export function textoAceito(consenteOfertas: boolean): string {
  const linhas = [CONSENTIMENTO_CONTEUDO];
  if (consenteOfertas) linhas.push(CONSENTIMENTO_OFERTAS);
  return linhas.join(" | ");
}
